import { useState, useEffect } from "react";
import { ApiUrl } from "../../ApiUrl";

const useFeeGroups = (selectedClassId, selectedCategoryId) => {
  const [feeGroups, setFeeGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const [academicYearId, setAcademicYearId] = useState(
    localStorage.getItem("academicSessionId"),
  );

  useEffect(() => {
    const handleSessionChange = () => {
      setAcademicYearId(localStorage.getItem("academicSessionId"));
    };
    window.addEventListener("academicSessionChanged", handleSessionChange);
    return () => {
      window.removeEventListener("academicSessionChanged", handleSessionChange);
    };
  }, []);

  useEffect(() => {
    if (!selectedClassId) return;

    const fetchFeeGroups = async () => {
      setLoading(true);
      setError(null);

      try {
        const params = new URLSearchParams({
          class_id: selectedClassId || "",
          category_id: "",
          academic_year_id: academicYearId || "",
          org_id: orgId || "",
          branch_id: branchId || "",
        });

        const url = `${
          ApiUrl.apiurl
        }FeeStructure/GetAllFeeStructureBasedOnClass/?${params.toString()}`;

        const response = await fetch(url);
        if (!response.ok) {
          const errorResponse = await response.json();
          if (
            String(errorResponse?.message || "")
              .toLowerCase()
              .includes("no record")
          ) {
            setFeeGroups([]);
            setError(null);
            return;
          }
          throw new Error(
            errorResponse.message || "Failed to fetch fee groups",
          );
        }

        const result = await response.json();

        const apiMessage = String(result?.message || "").toLowerCase();

        if (apiMessage === "success") {
          const allGroups = result.data || [];

          // Stopgap: backend may not be filtering by academic_year_id,
          // so enforce it client-side until the API is fixed.
          const filteredGroups =
            academicYearId && allGroups.length > 0
              ? allGroups.filter((group) => {
                  const groupYearId =
                    group.academic_year_id ??
                    group.academicYearId ??
                    group.academicyearId ??
                    group.academic_year ??
                    group.sessionId;

                  if (groupYearId === undefined) return true; // no field to filter on
                  return String(groupYearId) === String(academicYearId);
                })
              : allGroups;

          if (
            allGroups.length > 0 &&
            filteredGroups.length === allGroups.length &&
            allGroups[0].academic_year_id === undefined &&
            allGroups[0].academicYearId === undefined &&
            allGroups[0].academicyearId === undefined
          ) {
            console.warn(
              "useFeeGroups: fee structure records carry no academic-year field — backend is likely ignoring academic_year_id. Sample record:",
              allGroups[0],
            );
          }

          setFeeGroups(filteredGroups);
        } else if (apiMessage.includes("no record")) {
          setFeeGroups([]);
          setError(null);
        } else {
          throw new Error(result.message || "Failed to load fee groups.");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFeeGroups();
  }, [selectedClassId, academicYearId, orgId, branchId]);

  return { feeGroups, loading, error };
};

export default useFeeGroups;
